import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'primeng/api';
import { filter } from 'rxjs';

@Component({
  selector: 'app-pesquisa-servico-error',
  templateUrl: './pesquisa-servico-error.component.html',
  styleUrls: ['./pesquisa-servico-error.component.css'],
})
export class PesquisaServicoErrorComponent {
  error: Message[] = [];

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.error = [
        {
          severity: 'error',
          detail: params['message']
            ? params['message']
            : 'Aconteceu um erro desconhecido',
        },
      ];
    });
  }
}
